import { ArrowLeft, Eye, EyeOff } from 'lucide-react'
import styles from '@styles/LoginPage.module.css'
import { useNavigate } from 'react-router-dom'
import Loading from '@components/Loading'
import useAuth from '@hooks/useAuth'
import { useState } from 'react'

const Login = () => {
  const [showPassword, setShowPassword] = useState(false)
  const [password, setPassword] = useState('')
  const [error, setError] = useState(null)
  const [email, setEmail] = useState('')
  const { login, loading } = useAuth()
  const navigate = useNavigate()

  const handleChangeEmail = e => setEmail(e.target.value)
  const handleChangePassword = e => setPassword(e.target.value)

  const handleSubmit = async e => {
    e.preventDefault()
    try {
      await login(email, password)
      navigate('/admin')
    } catch (error) {
      setError(error.message)
    }
  }

  if (loading) return <Loading />

  return (
    <div className={styles.container}>
      <button className={styles.backButton} onClick={() => navigate('/')}>
        <ArrowLeft size={20} />
        <span>Volver al inicio</span>
      </button>

      <div className={styles.loginCard}>
        <h1>Iniciar Sesión</h1>
        <form onSubmit={handleSubmit}>
          <div className={styles.inputGroup}>
            <input
              type='email'
              id='email'
              placeholder='Email'
              onChange={handleChangeEmail}
              required
            />
          </div>
          <div className={styles.inputGroup}>
            <input
              type={showPassword ? 'text' : 'password'}
              id='password'
              placeholder='Contraseña'
              onChange={handleChangePassword}
              required
            />
            <button
              type='button'
              className={styles.eyeButton}
              onClick={() => setShowPassword(!showPassword)}
            >
              {showPassword ? <EyeOff size={20} /> : <Eye size={20} />}
            </button>
          </div>

          <button type='submit' className={styles.signInButton}>
            Ingresar
          </button>
          {error && <p className={styles.error}>{error}</p>}
        </form>
      </div>
    </div>
  )
}

export default Login
